export const ds_LayoutBlock_Entry = `
    fragment ds_LayoutBlock_Entry on ds_LayoutBlock_Entry {
        id
        canonicalUid

        layout_TopSpacing
        layout_SpaceBetween
        layout_ColorTheme
        layout_ColorPalette
        layout_ContainerWidth
        layout_FullWidthBackground

        layout_contentBuilderLayout {
            grid
        }
        layout_contentBuilder {
            __typename
        }
    }
`
